/**
 * @Author: HaoJie
 * @Date: 2023-02-14 00:04:34
 * @LastEditTime: 2023-02-14 01:02:28
 * @LastEditors: HaoJie
 * @FilePath: \wedding-invitation-for-programmers\src\mock\data.js
 */
export default {
  code: `
// 今天是情人节
// 我来表演写代码助助兴！
// 呐，要开始咯...
const { 😆, 🤗 } = 🌎;
😆.say('情人节快乐!❤️');
🤗.response('好喔，你也是呀！😀');
Utils.happy(😆,🤗);
Utils.generateInvitation(😆,🤗);
// 好啦！写完了
// 要开始运行咯...`,
  executions: [
    {
      name: "初始化",
      time: "",
      duration: 0,
      visible: false,
    },
    {
      name: "解压中",
      time: "",
      duration: 0,
      visible: false,
    },
    {
      name: "组装中",
      time: "",
      duration: 0,
      visible: false,
    },
    {
      name: "打包中",
      time: "",
      duration: 0,
      visible: false,
    },
    {
      name: "微笑🙂",
      time: "",
      duration: 0,
      visible: false,
    },
    {
      name: "大笑😄",
      time: "",
      duration: 0,
      visible: false,
    },
    {
      name: "编译中...",
      time: "",
      visible: false,
    },
  ],
  barrages: [
    "66666666",
    "愿你美梦成真",
    "你的邀请函真是美",
    "人美心更美",
    "你是最棒的",
    "哇哇哇",
    "还差女朋友吗",
    "今晚翻你牌",
    "看朕给你打下的江山",
    "你写代码老快了",
    "你的代码真是棒",
    "😗 😙 😚 😋 ",
    "只要代码写得好，单身永远跑不了",
  ],
};
